<template>
  <UseDraggable :initialValue="{ x: 10, y: 120 }" class="fixed" v-if="sessionStore.debugMode">
    <div class="absolute right-0 top-0 block transform translate-x-1/2 -translate-y-1/2">
      <ViceButton @click="togglePanel" :icon="'xIcon'" circle></ViceButton>
    </div>
    <div
      class="
        rounded
        shadow-xl
        bg-vice-light-grey
        text-left text-black
        p-6
        pt-3
        flex flex-col
        gap-4
        text-sm
        max-w-xl
      "
    >
      <div class="cursor-move">
        <hr class="py-1" />
        <hr />
      </div>
      <div class="flex flex-col">
        <h4 class="font-bold mb-2 text-center">Debugger panel</h4>
        <ul class="flex flex-col gap-2">
          <li class="flex flex-col gap-2 justify-between">
            <div class="flex items-center gap-2">
              <div class="whitespace-nowrap font-bold">Session:</div>
            </div>
            <div class="flex gap-2">
              <ViceButton @click="resetSession" small white class="whitespace-nowrap">
                Reset session
              </ViceButton>
              <ViceButton disabled @click="resetSession" small white class="whitespace-nowrap">
                End session
              </ViceButton>
            </div>
          </li>
          <hr />
          <li class="flex flex-col gap-2 justify-between">
            <div class="flex items-center gap-2">
              <div class="whitespace-nowrap font-bold">Go to phase:</div>
            </div>

            <div class="flex gap-2">
              <ViceButton disabled @click="resetSession" small white class="whitespace-nowrap">
                Introduction
              </ViceButton>
              <ViceButton disabled @click="resetSession" small white class="whitespace-nowrap">
                Consultation
              </ViceButton>
              <ViceButton disabled @click="resetSession" small white class="whitespace-nowrap">
                Debrief
              </ViceButton>
            </div>
          </li>
          <hr />
          <li class="flex flex-col gap-2 justify-between">
            <div class="flex items-center gap-2">
              <div class="whitespace-nowrap font-bold">
                Smartglasses:
                <span
                  v-if="!streamingDeviceStore.devices.smartglasses.connected"
                  class="font-light"
                >
                  (not connected)
                </span>
              </div>
            </div>

            <div class="flex gap-2">
              <ViceButton
                :disabled="!streamingDeviceStore.devices.smartglasses.connected"
                @click="muteSmartglasses(true)"
                small
                white
                class="whitespace-nowrap"
              >
                Mute Vuzix
              </ViceButton>
              <ViceButton
                :disabled="!streamingDeviceStore.devices.smartglasses.connected"
                @click="muteSmartglasses(false)"
                small
                white
                class="whitespace-nowrap"
              >
                Unmute Vuzix
              </ViceButton>
              <ViceButton
                :disabled="!streamingDeviceStore.devices.smartglasses.connected"
                @click="disconnectSmartglasses"
                small
                white
                class="whitespace-nowrap"
              >
                Kick Vuzix
              </ViceButton>
            </div>
            <div class="flex">
              <div class="mt-1 flex rounded-md shadow-sm w-full">
                <div class="relative flex flex-grow items-stretch focus-within:z-10">
                  <div
                    class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                  ></div>
                  <input
                    v-model="smartglassesMessage"
                    type="text"
                    class="
                      block
                      w-full
                      rounded-none rounded-l-md
                      border-vice-dark-grey border-r-0
                      sm:text-sm
                    "
                    placeholder="Message"
                  />
                </div>
                <ViceButton
                  @click="sendMessageToSmartglasses"
                  icon="ChevronDoubleRightIcon"
                  white
                  class="rounded-l-none"
                >
                  Send
                </ViceButton>
              </div>
            </div>
          </li>
          <hr />
        </ul>
      </div>
    </div>
  </UseDraggable>
</template>

<script>
import { UseDraggable } from '@vueuse/components';
import { ref, onMounted } from 'vue';
import tinykeys from 'tinykeys';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import PhaseService from '@/Services/PhaseService';
import useSessionStore from '@/Stores/useSessionStore';
import useIOTDevicesStore from '@/Stores/useIOTDevicesStore';

export default {
  name: 'DebugPanel',
  props: {},
  components: { ViceButton, UseDraggable },
  setup() {
    const smartglassesMessage = ref('Allo allo!');
    const sessionStore = useSessionStore();
    const streamingDeviceStore = useIOTDevicesStore();

    onMounted(() => {
      if (window.localStorage.getItem('debugMode')) {
        sessionStore.debugMode = JSON.parse(window.localStorage.getItem('debugMode'));
      }

      tinykeys(window, {
        'h a c k': () => {
          togglePanel();
        },
      });
    });
    const togglePanel = () => {
      sessionStore.debugMode = !sessionStore.debugMode;
      window.localStorage.setItem('debugMode', sessionStore.debugMode);
    };

    const resetSession = async () => {
      await PhaseService.resetPhasesData().then(() => {
        window.location.reload();
      });
    };

    const disconnectSmartglasses = () => {
      sessionStore.deviceMessageSender.turnOffSmartGlass();
    };

    const sendMessageToSmartglasses = () => {
      sessionStore.deviceMessageSender.sendSmartGlassTextMessage({
        content: smartglassesMessage.value,
        senderInfo: {
          name: 'Nighthawk',
        },
      });
    };
    const muteSmartglasses = (shouldMute) => {
      sessionStore.deviceMessageSender.toggleSmartglassAudioIO(shouldMute);
    };

    return {
      togglePanel,
      resetSession,
      sessionStore,
      disconnectSmartglasses,
      muteSmartglasses,
      sendMessageToSmartglasses,
      smartglassesMessage,
      streamingDeviceStore,
    };
  },
};
</script>
